import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;
  color: ${props => (props.isActive ? 'var(--text-color)' : 'var(--grey)')};
  transition: color var(--hover-transition);
`;
